import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const DeleteConfirmationModal = ({ post, isOpen, onClose, onConfirm }) => {
  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="delete-dialog-title"
      aria-describedby="delete-dialog-description"
      PaperProps={{
        sx: {
          borderRadius: 4,
          p: 1,
          width: "100%",
          maxWidth: 420,
          boxShadow: 8,
        },
      }}
    >
      <DialogTitle
        id="delete-dialog-title"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          fontWeight: "bold",
          fontSize: "1.3rem",
          px: 4,
          pt: 3,
          pb: 1,
        }}
      >
        <WarningAmberRoundedIcon color="warning" sx={{ fontSize: 32 }} />
        <span>Delete Post?</span>
      </DialogTitle>

      <DialogContent sx={{ px: 4, pb: 0 }}>
        <DialogContentText
          id="delete-dialog-description"
          sx={{ color: "text.secondary", fontSize: "1.05rem" }}
        >
          A jeni te sigurt që dëshironi me fshi <strong>"{post?.title}"</strong>? Ky veprim është i pakthyeshëm
        </DialogContentText>
      </DialogContent>

      <DialogActions sx={{ px: 4, pb: 3, pt: 2, justifyContent: "flex-end" }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="inherit"
          sx={{ minWidth: 100 }}
          aria-label="Cancel delete"
        >
          Anulo
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="error"
          sx={{ minWidth: 100, boxShadow: 2, fontWeight: 600 }}
          aria-label="Confirm delete"
        >
          Fshij
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
